import { AuthProvider, useBadgeLetter } from '@dfds-pax/auth'
import { LoginBadge } from '@dfds-pax/auth/login-badge'

import './globals.css'

const AppContent = ({ locale }: { locale: string }) => {
  const badgeLetter = useBadgeLetter()

  return <LoginBadge avatarInitial={badgeLetter} locale={locale} />
}

const App = () => {
  const [locale = 'en'] = window.location.pathname.split('/').filter(Boolean)

  return (
    <div id="azure-login">
      <AuthProvider>
        <AppContent locale={locale} />
      </AuthProvider>
    </div>
  )
}

export default App
